import { AssetBlok, sizes } from "@/components/bloks/Asset";
import type { StoryblokAsset } from "@/storyblok-base";
import { Link } from "@/i18n/Link";
import styles from "./ArticleCard.module.css";
import { clsx } from "@frend-digital/ui";
import { Translate } from "@/components/Translate";

export interface ArticleCardProps {
	image?: StoryblokAsset;
	title?: string;
	description?: string;
	className?: string;
	tags?: string[];
	slug?: string;
}

export const ArticleCard = ({
	image,
	title,
	description,
	className,
	tags,
	slug,
}: ArticleCardProps) => {
	return (
		<Link href={slug ? `/${slug}` : "#"} className={clsx(styles.root, className)}>
			<article className={styles.content}>
				<div className={styles.imageContainer}>
					{tags && tags.length > 0 && (
						<div className={styles.tagsContainer}>
							{tags.map((tag) => (
								<span key={tag} className={styles.tag}>
									<Translate>{tag}</Translate>
								</span>
							))}
						</div>
					)}
					{image && <AssetBlok source={image} sizes={sizes(50, undefined, 33)} />}
				</div>
				<div className={styles.info}>
					<h3 className={styles.title}>{title}</h3>
					<p className={styles.text}>{description}</p>
				</div>
			</article>
		</Link>
	);
};
